import {injectable} from "inversify";
import {LineupEnum} from "@/modules/base/enums";
import {Team} from "@/modules/team/entity";
import AbstractLineupper from "@/modules/ai/services/lineupper/AbstractLineupper";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";
import {Match} from "@/modules/match/entity";
import {app} from "@/di";
import {BeforeLineupChangedEndEvent} from "@/modules/team/events/BeforeLineupChangedEndEvent";
import {AfterLineupChangedEndEvent} from "@/modules/team/events/AfterLineupChangedEndEvent";

@injectable()
export default class BestMatchingLineupper extends AbstractLineupper {
  // constructor(
  // todo: does not work, because circular dependency as it seems
  // @inject(ConfigRepository) private configRepository: ConfigRepository,
  // ) {
  //   super();
  // }

  async lineup(team: Team, nextMatch?: Match) {
    await this.em.emitAsync(new BeforeLineupChangedEndEvent);

    const configRepository = app.get(ConfigRepository);

    console.time('BestMatchingLineupper::removePlayers');
    await super.lineup(team);
    console.timeEnd('BestMatchingLineupper::removePlayers');

    let players = collect(team.players);

    if (nextMatch) {
      players = players
        .filter(player => !player.suspensions.find(s => s.competitionId === nextMatch.matchday.division.competitionId));
    }

    const similarPositions = configRepository.get('formations.positions.similar');
    const formationDef = configRepository.get('formations.all')[team.formation];
    let noMatching: LineupEnum[] = [];

    // perfect matching player for this position
    await times(11, 1).forEachAsync(async (lineup: LineupEnum) => {
      const player = players
        .where('position', formationDef[lineup].position)
        .where('lineup', null)
        .sortByDesc('skill')
        .first();

      if (!player) {
        noMatching.push(lineup);
        return;
      }

      player.lineup = lineup;
      await player.save();
    });

    // lineup up players with similar positions
    await noMatching.forEachAsync(async (lineup: LineupEnum) => {
      const position = formationDef[lineup].position;

      const player = players
        .where('lineup', null)
        .whereIn('position', similarPositions[position])
        .sortByDesc('skill')
        .first();

      if (player) {
        player.lineup = lineup;
        await player.save();
        noMatching = noMatching.filter(l => l !== lineup);
      }
    });

    // lineup not lined up players randomly
    await noMatching.forEachAsync(async (lineup: LineupEnum) => {
      const player = players.where('lineup', null).sortByDesc('skill').first();

      if (player) {
        player.lineup = lineup;
        await player.save();
      }
    });

    await this.em.emitAsync(new AfterLineupChangedEndEvent);
  }
}
